import { createAsyncThunk } from "@reduxjs/toolkit";
import { cloudChiprApi } from "../../../services/cloudchipr.api";
import { IntegrationType } from "../../../components/pages/integrations/components/integrations-create/components/common/integration-type/IntegrationTypeCard";

export const getIntegrationByIdThunk = createAsyncThunk(
  "integrations/getIntegrationById",
  async ({ id, type }: { id: string; type: IntegrationType }, { dispatch }) => {
    return await dispatch(
      cloudChiprApi.endpoints.getUsersMeByTypeIntegrationsAndIntegrationId.initiate(
        { integrationId: id, type },
        { forceRefetch: true },
      ),
    );
  },
);
